import { Popover } from '@mantine/core';
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import { IconLink } from '@tabler/icons-react';
import { useState } from 'react';

import { ZorroButton as Button } from '../Button';
import { ZorroGroup as Group } from '../Group';
import { TextInput } from '../v2/TextInput';

function normalizeUrl(input: string): string | null {
  const value = input.trim();
  if (!value) return null;

  try {
    return new URL(value, window.location.href).toString();
  } catch {
    return null;
  }
}

export const ZorroRichTextEditorLink = () => {
  const { editor } = useRichTextEditorContext();
  const [opened, setOpened] = useState(false);
  const [raw, setRaw] = useState('');

  const apply = () => {
    const href = normalizeUrl(raw);
    if (!href) return;

    editor
      ?.chain()
      .focus()
      .extendMarkRange('link')
      .setLink({
        href,
        target: '_blank',
        rel: 'noopener noreferrer',
      })
      .run();

    setOpened(false);
    setRaw('');
  };

  return (
    <Popover opened={opened} onChange={setOpened}>
      <Popover.Target>
        <RichTextEditor.Control
          onClick={() => setOpened((event) => !event)}
          title="Insert link"
        >
          <IconLink size={16} />
        </RichTextEditor.Control>
      </Popover.Target>
      <Popover.Dropdown>
        <Group>
          <TextInput
            value={raw}
            onChange={(event) => setRaw(event.currentTarget.value)}
            size="md"
          />
          <Button size="xs" onClick={apply}>
            Save
          </Button>
        </Group>
      </Popover.Dropdown>
    </Popover>
  );
};
